/**
 * Created by Denis Kuzin on 10 november 2025
 */

const TreasureSearchMerge3Adapter = {
    collectPrize: function (rewardsList, callback) {
        cleverapps.focusManager.display({
            focus: "TreasureSearchReward",
            stack: true,
            action: (f) => {
                new RewardWindow(rewardsList, {
                    callback
                });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};